<div class="login-register" style="background-image:url(assets/images/background/login-bg.jpg);">
    <div class="login-register-box">
        <mat-card class="m-t-10">
            <mat-card-content>
                <form [formGroup]="loginForm" id="loginform" class="login-form">
                    <div class="text-center">
                        <img alt="homepage" class="main-logo margin-bottom" src="assets/images/iotechlogo.png">
                    </div>
                    <div fxLayout="row wrap">

                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <mat-form-field appearance="outline" class="p-b-0">
                                <mat-icon matPrefix>person</mat-icon>
                                <mat-label>Username</mat-label>
                                <input matInput placeholder="Username" #u1 formControlName="username">
                            </mat-form-field>
                        </div>
                        <!-- col full-->
                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <mat-form-field appearance="outline" class="p-b-5">
                                <mat-icon matPrefix>lock</mat-icon>
                                <mat-label>Password</mat-label>
                                <input (keydown.enter)="check(u1.value, p2.value)" matInput type="password" placeholder="Password" #p2 formControlName="password">
                            </mat-form-field>
                        </div>

                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <button mat-raised-button color="primary" class="btn-block btn-lg m-t-2 m-b-2"
                                (click)="check(u1.value, p2.value)" type="button">Login</button>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
